const HT_TOKEN = '226345edc7ae6f48e21d40d78898be15';

const addScript = () => {
  const script = document.createElement('script');
  script.src = `//api.handtalk.me/plugin/latest/handtalk.min.js`;
  script.onload = () => {
    try {
      new HT({
        token: HT_TOKEN,
        doNotTrack: 'true',
        align: 'default',
        side: 'right',
      });
    } catch (e) {
      console.error('HandTalk indisponível!');
    }
  };
  document.body.appendChild(script);
};

export const addHandTalk = () => {
  addScript();
};
